module.exports = __webpack_public_path__ + "static/media/menu.a6b03301.svg";